import { put } from 'redux-saga/effects'
import { fetchFollowupsByOperatorAction } from '../../handles'
import { fetchFollowupsByOperator, FetchFollowupsByOperatorResponse } from '../_http/followup'

export function* fetchFollowupsByOperatorSaga(action: ReturnType<typeof fetchFollowupsByOperatorAction.request>) {
  try {
    const response: FetchFollowupsByOperatorResponse = yield fetchFollowupsByOperator(action.payload)
    yield put(
      fetchFollowupsByOperatorAction.success({
        followups: response.followups,
        total: response.total,
        page: response.page,
        totalPages: response.totalPages
      })
    )
  } catch (error) {
    yield put(fetchFollowupsByOperatorAction.failure())
  }
}
